/**
 * Helpers for the concierge Activity tab (calls, voicemails and texts in one
 * feed from /clients/api/staff/activity-feed/). Pure functions only — see
 * activityFeed.test.js.
 */

export const ACTIVITY_TYPE_FILTERS = [
  { value: "all", label: "All activity" },
  { value: "calls", label: "Calls" },
  { value: "voicemails", label: "Voicemails" },
  { value: "texts", label: "Texts" },
]

const ROLE_LABELS = {
  owner: "Owner",
  member: "Team member",
  executive_caller: "Executive caller",
  concierge: "Concierge",
  texter: "Texter",
  staff: "Staff",
}

export function activityRowKind(row) {
  if (row?.type === "call") {
    if (row.amd_action === "voicemail_dropped") {
      return { label: "Voicemail left", color: "warning" }
    }
    if (row.amd_action === "texted") {
      return { label: "Call · text", color: "warning" }
    }
    return { label: "Call", color: "primary" }
  }
  if (row?.type === "voicemail") {
    return { label: "Voicemail", color: "secondary" }
  }
  if (row?.type === "text") {
    return {
      label: row.direction === "incoming" ? "Text in" : "Text out",
      color: row.direction === "incoming" ? "info" : "success",
    }
  }
  return { label: row?.type || "—", color: "default" }
}

export function roleLabel(role) {
  if (!role) return ""
  return ROLE_LABELS[role] || String(role).replace(/_/g, " ")
}

export function actorLabel(actor) {
  if (!actor) return "—"
  const role = roleLabel(actor.role)
  return role ? `${actor.name} (${role})` : actor.name
}

export function counterpartyLabel(counterparty) {
  if (!counterparty) return "—"
  const {
    name,
    phone,
    lead_source: leadSource,
    lead_ref_id: leadRef,
  } = counterparty
  if (name && phone) return `${name} · ${phone}`
  if (name || phone) return name || phone
  if (leadRef) return `Lead ${leadSource ? `${leadSource} ` : ""}#${leadRef}`
  return "—"
}

export function formatDurationSeconds(seconds) {
  const total = Number(seconds)
  if (!Number.isFinite(total) || total <= 0) return ""
  const minutes = Math.floor(total / 60)
  const rest = Math.round(total % 60)
  if (!minutes) return `${rest}s`
  return `${minutes}m ${String(rest).padStart(2, "0")}s`
}

/** Thread message from the API in the shape SmsMessageCard renders. */
export function threadMessageToCard(message, counterparty) {
  const inbound = message.direction === "incoming"
  const phone = counterparty?.phone || ""
  return {
    id: message.id,
    is_inbound: inbound,
    candidate_name: counterparty?.name || "",
    from_address: inbound ? phone : "",
    to_address: inbound ? "" : phone,
    sender_name: inbound
      ? ""
      : message.sender
      ? actorLabel(message.sender)
      : "Unknown sender",
    received_at: message.timestamp,
    text: message.text,
  }
}
